// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3t0cs","savePackageButton":"ClientWallet_savePackageButton__1eQKH"};